import { render, staticRenderFns } from "./RenewalEuropeanMobileDetail.vue?vue&type=template&id=23aa2d0c&scoped=true"
import script from "./RenewalEuropeanMobileDetail.vue?vue&type=script&lang=js"
export * from "./RenewalEuropeanMobileDetail.vue?vue&type=script&lang=js"
import style0 from "./RenewalEuropeanMobileDetail.vue?vue&type=style&index=0&id=23aa2d0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23aa2d0c",
  null
  
)

export default component.exports